import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';

const IdentificationDetail = lazy(() => import('./identification-detail/identification-detail.component'));
const IdentificationOverview = lazy(() => import('./identification-overview/admin-identification-overview.component'));
const IdentificationUpdate = lazy(() => import('./identification-update/identification-update.component'));

export function IdentificationRoutes() {
    return (
        <Route path=':identificationType'>
            <Route
                index
                element={<Navigate to='../detail' />}
            />
            <Route path=':identificationId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <IdentificationDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <IdentificationUpdate />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}

export function AdminIdentificationRoutes() {
    return (
        <Route path='identifications'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <IdentificationOverview />
                    </AsyncComponent>
                }
            />
            {IdentificationRoutes()}
        </Route>
    );
}
